/*
 * Product page bundles: PRODUCT ONLY / BUNDLE tabs + bundle cards (BURGA-style).
 *
 * Data comes from <script type="application/json" data-bundle-config> (product-bundle-options.liquid).
 *
 * Add to cart (does not replace the theme's add to cart):
 * 1. In bundle mode the case gets hidden properties _bundle / _bundle_id and is added by the
 *    theme's product-form as usual (Easify case type included).
 * 2. After that request succeeds (PUB_SUB_EVENTS.cartUpdate, source "product-form"),
 *    the bundle accessories are added with /cart/add and the cart drawer is refreshed.
 * If the case is not added (error / validation), accessories are not added either.
 *
 * Prices are display only. The real discount is set up in Shopify.
 */
(function () {
  if (window.__productBundleInit) return;
  window.__productBundleInit = true;

  var PENDING_TTL = 15000;

  function money(cents) {
    if (typeof formatMoney === 'function' && window.theme && window.theme.settings) {
      return formatMoney(cents, window.theme.settings.money_with_currency_format);
    }
    return (cents / 100).toFixed(2);
  }

  function parseCents(text) {
    var cleaned = String(text || '').replace(/[^0-9.,-]/g, '');
    if (!cleaned) return 0;
    var pos = Math.max(cleaned.lastIndexOf(','), cleaned.lastIndexOf('.'));
    var normalized =
      pos === -1
        ? cleaned
        : cleaned.slice(0, pos).replace(/[.,]/g, '') + '.' + cleaned.slice(pos + 1).replace(/[^0-9]/g, '');
    var amount = parseFloat(normalized);
    return isNaN(amount) ? 0 : Math.round(amount * 100);
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // "Samsung Galaxy S25 5G" and "Samsung S25" -> "samsung s25"
  function normModel(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\bgalaxy\b/g, '')
      .replace(/\b[45]g\b/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  /* Bundle jobs shared with cart-bundle-sync.js (sessionStorage "bundle-jobs") */
  function readBundleJobs() {
    try {
      return JSON.parse(sessionStorage.getItem('bundle-jobs') || '{}');
    } catch (e) {
      return {};
    }
  }
  function writeBundleJobs(jobs) {
    try {
      sessionStorage.setItem('bundle-jobs', JSON.stringify(jobs));
    } catch (e) {}
  }
  function saveBundleJob(id, items) {
    var jobs = readBundleJobs();
    jobs[id] = { items: items, at: Date.now(), done: false };
    writeBundleJobs(jobs);
  }
  function bundleJobDone(id) {
    var job = readBundleJobs()[id];
    return !!(job && job.done);
  }
  function markBundleJob(id) {
    var jobs = readBundleJobs();
    if (jobs[id]) {
      jobs[id].done = true;
      writeBundleJobs(jobs);
    }
  }

  function productInfoFor(sectionId) {
    return document.getElementById('ProductInfo-' + sectionId);
  }

  function mainFormFor(sectionId) {
    return document.getElementById('product-form-' + sectionId);
  }

  /* ---------- Tabs ---------- */
  if (!customElements.get('bundle-tabs')) {
    customElements.define(
      'bundle-tabs',
      class BundleTabs extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.info = productInfoFor(this.sectionId) || this.closest('product-info');
          if (!this.info) return;
          this.mode = this.dataset.defaultMode === 'bundle' ? 'bundle' : 'product';
          // Coming from "change design" inside a bundle: stay in bundle mode
          try {
            if (sessionStorage.getItem('bundle-mode') === 'bundle') this.mode = 'bundle';
            sessionStorage.removeItem('bundle-mode');
          } catch (e) {}

          this.querySelectorAll('[data-bundle-mode]').forEach((button) => {
            button.addEventListener('click', () => this.setMode(button.dataset.bundleMode));
          });

          // bundle-options tells how many bundles are available for the current model
          this.onAvailability = (event) => {
            if (!event.detail || event.detail.sectionId !== this.sectionId) return;
            this.hidden = event.detail.count === 0;
            this.setMode(this.hidden ? 'product' : this.mode, true);
          };
          document.addEventListener('bundle:availability', this.onAvailability);
          this.setMode('product', true);
          // In case bundle-options rendered before this element
          var options = document.querySelector('bundle-options[data-section-id="' + this.sectionId + '"]');
          if (options && typeof options.availableCount === 'number') {
            this.onAvailability({ detail: { sectionId: this.sectionId, count: options.availableCount } });
          }
        }

        disconnectedCallback() {
          document.removeEventListener('bundle:availability', this.onAvailability);
        }

        setMode(mode, silent) {
          if (!this.info) return;
          if (!silent) this.mode = mode;
          this.info.setAttribute('data-bundle-mode', mode);
          this.querySelectorAll('[data-bundle-mode]').forEach((button) => {
            button.setAttribute('aria-selected', String(button.dataset.bundleMode === mode));
          });
        }
      }
    );
  }

  /* ---------- Options ---------- */
  if (!customElements.get('bundle-options')) {
    customElements.define(
      'bundle-options',
      class BundleOptions extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.info = productInfoFor(this.sectionId) || this.closest('product-info');
          this.list = this.querySelector('[data-bundle-list]');
          var configEl = this.querySelector('[data-bundle-config]');
          try {
            this.config = JSON.parse(configEl.textContent);
          } catch (e) {
            console.error('Bundle config error', e);
            return;
          }
          this.text = this.config.text || {};
          this.slots = {};
          this.config.slots.forEach((slot) => {
            this.slots[slot.slot] = slot;
            // default choice per slot
            var itemIndex = 0;
            if (slot.selected) {
              var found = slot.items.findIndex((item) => item.handle === slot.selected);
              if (found > -1) itemIndex = found;
            }
            slot.itemIndex = itemIndex;
            slot.variantId = null;
          });
          this.aliases = {};
          (this.config.aliases || []).forEach((pair) => {
            this.aliases[normModel(pair[0])] = normModel(pair[1]);
          });
          this.bundles = (this.config.bundles || []).map((bundle) => {
            bundle.slotList = String(bundle.slots || '')
              .split(',')
              .map((n) => parseInt(n, 10))
              .filter((n) => n > 0 && this.slots[n]);
            return bundle;
          });
          this.modelTitle = this.config.case.variantTitle || '';
          this.selectedIndex = null;
          this.openPanel = null;
          this.pending = null;

          this.render = this.render.bind(this);
          this.debouncedRender = () => {
            clearTimeout(this.renderTimer);
            this.renderTimer = setTimeout(this.render, 150);
          };

          this.addEventListener('click', this.onClick.bind(this));
          this.addEventListener('change', this.onChange.bind(this));
          if (this.info) {
            // Easify case type clicks happen elsewhere in product-info
            // Easify updates properties[Case Type] with a delay (switching back to Tough
            // is slower than to Magsafe), so render again a bit later.
            this.onInfoClick = (event) => {
              if (this.contains(event.target)) return;
              if (event.isTrusted && event.target.closest && event.target.closest('.po-optionSwatch-root')) {
                this.caseTypeChosen = true;
              }
              this.debouncedRender();
              clearTimeout(this.lateRender1);
              clearTimeout(this.lateRender2);
              this.lateRender1 = setTimeout(this.render, 600);
              this.lateRender2 = setTimeout(this.render, 1500);
            };
            this.info.addEventListener('click', this.onInfoClick);
          }

          this.onSubmit = this.onSubmit.bind(this);
          document.addEventListener('submit', this.onSubmit, true);

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              var variant = event && event.data && event.data.variant;
              if (variant && variant.title) this.modelTitle = variant.title;
              this.debouncedRender();
            });
            this.unsubCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
            this.unsubError = subscribe(PUB_SUB_EVENTS.cartError, () => {
              // keep pending.job: the cart check adds the accessories only if the case was added
              if (this.pending && !this.pending.job) this.pending = null;
            });
          }

          if (this.info && typeof MutationObserver === 'function') {
            this.modeObserver = new MutationObserver(() => {
              this.syncButtonPrice();
              this.applyMagsafeDefault();
            });
            this.modeObserver.observe(this.info, { attributes: true, attributeFilter: ['data-bundle-mode'] });
            // The theme rewrites the button price on variant change (also after our render):
            // re-apply the bundle total whenever the button text changes
            var priceForm = mainFormFor(this.sectionId);
            if (priceForm) {
              this.priceObserver = new MutationObserver(() => {
                if (this.priceSyncQueued) return;
                this.priceSyncQueued = true;
                Promise.resolve().then(() => {
                  this.priceSyncQueued = false;
                  this.syncButtonPrice();
                });
              });
              this.priceObserver.observe(priceForm, { childList: true, subtree: true, characterData: true });
            }
          }

          this.render();
          // Easify renders its swatches after load
          setTimeout(this.render, 800);
          setTimeout(this.render, 2500);
        }

        disconnectedCallback() {
          document.removeEventListener('submit', this.onSubmit, true);
          if (this.info && this.onInfoClick) this.info.removeEventListener('click', this.onInfoClick);
          if (this.unsubVariant) this.unsubVariant();
          if (this.unsubCart) this.unsubCart();
          if (this.unsubError) this.unsubError();
          if (this.modeObserver) this.modeObserver.disconnect();
          if (this.priceObserver) this.priceObserver.disconnect();
        }

        /* ----- case ----- */

        caseFields() {
          var form = mainFormFor(this.sectionId);
          if (!form) return [];
          // form.elements also contains Easify inputs placed outside the form (form="..." attribute)
          return Array.prototype.filter.call(form.elements, function (el) {
            return el.name && el.name.indexOf('properties[') === 0;
          });
        }

        /* Easify writes e.g. properties[Case Type] = "Magsafe (€5,00)" (shopper's currency).
           Fallback: properties[_po:items:addon] JSON with "price" in major units. */
        easifyAddonCents() {
          var fields = this.caseFields();
          var total = 0;
          var found = false;
          fields.forEach(function (input) {
            if (input.name.indexOf('properties[_') === 0) return;
            if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;
            var match = String(input.value || '').match(/\(([^()]*\d[^()]*)\)\s*$/);
            if (match) {
              total += parseCents(match[1]);
              found = true;
            }
          });
          if (found) return total;
          var addonInput = fields.filter(function (el) {
            return el.name === 'properties[_po:items:addon]';
          })[0];
          if (!addonInput || !addonInput.value) return 0;
          try {
            var groups = JSON.parse(addonInput.value);
            (Array.isArray(groups) ? groups : []).forEach(function (group) {
              (Array.isArray(group) ? group : [group]).forEach(function (item) {
                if (item && typeof item.price === 'number') {
                  total += Math.round(item.price * 100) * (item.variantQty || 1);
                }
              });
            });
          } catch (e) {
            return 0;
          }
          return total;
        }

        caseTypeLabel() {
          var label = '';
          this.caseFields().forEach(function (input) {
            if (label || input.name.indexOf('properties[_') === 0) return;
            if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;
            label = String(input.value || '').replace(/\s*\([^()]*\d[^()]*\)\s*$/, '');
          });
          return label;
        }

        casePriceCents() {
          var base =
            this.info && typeof this.info.currentVariantPriceCents === 'number' ? this.info.currentVariantPriceCents : null;
          if (base === null && this.info && this.info.dataset.variantPrice) base = parseInt(this.info.dataset.variantPrice, 10);
          if (base === null || isNaN(base)) return null;
          return base + this.easifyAddonCents();
        }

        modelSelect() {
          return this.info ? this.info.querySelector('variant-selects select') : null;
        }

        /* MagSafe bundle: power bank and ring need a magnetic case, so the Magsafe case
           type is selected by default when the product offers it. A case type the
           shopper picks himself is kept. */
        applyMagsafeDefault() {
          if (this.caseTypeChosen || this.magsafeSwitching || !this.isBundleMode()) return;
          var entry = (this.available || []).find((a) => a.bundle.index === this.selectedIndex);
          if (!entry) return;
          var wantMagsafe = /magsafe/i.test(entry.bundle.title || '');
          var isMagsafe = /magsafe/i.test(this.caseTypeLabel());
          var target;
          if (wantMagsafe && !isMagsafe) {
            target = /magsafe/i;
          } else if (!wantMagsafe && isMagsafe && this.magsafeAuto) {
            // Magsafe was our default for the MagSafe bundle, not the shopper's choice:
            // other bundles go back to the first (standard) case type
            target = null;
          } else {
            return;
          }
          var swatches = this.easifySwatches();
          var swatch = target
            ? swatches.find(function (root) {
                return target.test(root.textContent || '');
              })
            : swatches.find(function (root) {
                return !/magsafe/i.test(root.textContent || '');
              });
          if (!swatch) return;
          // try once per model and bundle, so a type Easify refuses does not loop
          var key = String(this.modelTitle || '') + '|' + this.selectedIndex;
          if (this.magsafeTried === key) return;
          this.magsafeTried = key;
          this.magsafeAuto = !!target;
          var clickable =
            swatch.querySelector('.po-imageOption-swatchWrapperItem, .po-imageOption-swatchLabel, button, input, label, [role="radio"]') ||
            swatch;
          this.magsafeSwitching = true;
          clickable.click();
          setTimeout(() => {
            this.magsafeSwitching = false;
            this.render();
          }, 700);
          setTimeout(this.render, 1600);
        }

        easifySwatches() {
          return this.info ? Array.prototype.slice.call(this.info.querySelectorAll('.po-optionSwatch-root')) : [];
        }

        /* ----- slots ----- */

        resolveSlot(slot) {
          var item = slot.items[slot.itemIndex] || slot.items[0];
          if (!item) return null;
          var variant = null;
          if (slot.type === 'product_model') {
            var target = normModel(this.modelTitle);
            if (this.aliases[target]) target = this.aliases[target];
            variant = item.variants.find((v) => v.available && normModel(v.title) === target) || null;
          } else {
            if (slot.variantId) variant = item.variants.find((v) => v.id === slot.variantId && v.available) || null;
            if (!variant) variant = item.variants.find((v) => v.available) || null;
          }
          if (!variant) return null;
          return { slot: slot, item: item, variant: variant };
        }

        resolveBundle(bundle) {
          var lines = [];
          for (var i = 0; i < bundle.slotList.length; i++) {
            var resolved = this.resolveSlot(this.slots[bundle.slotList[i]]);
            if (!resolved) {
              if (this.config.missing === 'skip_item') continue;
              return null;
            }
            lines.push(resolved);
          }
          return lines.length ? lines : null;
        }

        /* ----- render ----- */

        render() {
          if (!this.config || !this.list) return;
          var caseCents = this.casePriceCents();
          var caseType = this.caseTypeLabel();
          var available = [];
          this.bundles.forEach((bundle) => {
            var lines = this.resolveBundle(bundle);
            if (lines) available.push({ bundle: bundle, lines: lines });
          });

          if (available.length && !available.some((a) => a.bundle.index === this.selectedIndex)) {
            var highlighted = available.find((a) => a.bundle.highlight);
            this.selectedIndex = (highlighted || available[0]).bundle.index;
          }
          this.available = available;

          var html = available.map((entry) => this.renderCard(entry, caseCents, caseType)).join('');
          // Re-rendering is frequent (Easify, variant and price updates). Rebuilding the
          // list re-creates every <img>, which makes the thumbnails flicker: skip
          // identical renders and move the already loaded images into the new markup.
          if (html !== this.renderedHtml) {
            var oldImages = {};
            Array.prototype.forEach.call(this.list.querySelectorAll('img'), function (img) {
              var key = img.getAttribute('src');
              (oldImages[key] = oldImages[key] || []).push(img);
            });
            this.list.innerHTML = html;
            this.renderedHtml = html;
            Array.prototype.forEach.call(this.list.querySelectorAll('img'), function (img) {
              var reuse = oldImages[img.getAttribute('src')];
              if (reuse && reuse.length) img.replaceWith(reuse.shift());
            });
          }
          this.updateSaving(caseCents);
          this.syncButtonPrice();

          this.availableCount = available.length;
          this.applyMagsafeDefault();
          document.dispatchEvent(
            new CustomEvent('bundle:availability', {
              detail: { sectionId: this.sectionId, count: available.length },
            })
          );
        }

        priceHtml(full, discount) {
          var now = Math.round(full * (1 - discount / 100));
          return (
            (now < full ? '<s class="bundle-line__compare">' + esc(money(full)) + '</s> ' : '') +
            '<span class="bundle-line__price">' + esc(money(now)) + '</span>'
          );
        }

        renderCard(entry, caseCents, caseType) {
          var bundle = entry.bundle;
          var selected = bundle.index === this.selectedIndex;
          var discount = parseFloat(bundle.discount) || 0;
          var full = caseCents === null ? null : caseCents;
          entry.lines.forEach(function (line) {
            if (full !== null) full += line.variant.price;
          });
          var total = full === null ? null : this.bundleTotal(caseCents, entry.lines, discount);

          var out = '<div class="bundle-card' + (selected ? ' is-selected' : '') + (bundle.highlight ? ' bundle-card--highlight' : '') + '" data-bundle-card="' + bundle.index + '">';
          if (bundle.highlight && this.text.highlight) {
            out += '<div class="bundle-card__ribbon">' + esc(this.text.highlight) + '</div>';
          }
          out += '<button type="button" class="bundle-card__head" data-bundle-select="' + bundle.index + '" aria-pressed="' + selected + '">';
          out += '<span class="bundle-card__radio" aria-hidden="true"></span>';
          out += '<span class="bundle-card__info"><span class="bundle-card__title">' + esc(bundle.title);
          if (bundle.badge) out += ' <span class="bundle-card__badge">' + esc(bundle.badge) + '</span>';
          out += '</span>';
          if (bundle.text) out += '<span class="bundle-card__text">' + esc(bundle.text) + '</span>';
          out += '</span>';
          out += '<span class="bundle-card__prices">';
          if (total !== null) {
            if (total < full) out += '<s class="bundle-card__compare">' + esc(money(full)) + '</s>';
            out += '<span class="bundle-card__total">' + esc(money(total)) + '</span>';
          }
          out += '</span></button>';

          if (selected) {
            out += '<div class="bundle-card__lines">';
            out += this.renderCaseLine(bundle, caseCents, caseType, discount);
            entry.lines.forEach((line) => {
              out += '<div class="bundle-card__plus" aria-hidden="true">+</div>';
              out += this.renderLine(bundle, line, discount);
            });
            out += '</div>';
          } else {
            out += '<div class="bundle-card__thumbs">';
            out += this.thumb(this.config.case.image, this.config.case.title);
            entry.lines.forEach((line) => {
              out += '<span class="bundle-card__plus" aria-hidden="true">+</span>';
              out += this.thumb(line.variant.image || line.item.image, line.item.title);
            });
            out += '</div>';
          }
          out += '</div>';
          return out;
        }

        bundleTotal(caseCents, lines, discount) {
          var total = Math.round(caseCents * (1 - discount / 100));
          lines.forEach(function (line) {
            total += Math.round(line.variant.price * (1 - discount / 100));
          });
          return total;
        }

        thumb(src, alt) {
          return (
            '<span class="bundle-thumb">' +
            (src ? '<img src="' + esc(src) + '" alt="' + esc(alt) + '" loading="lazy" width="96" height="96">' : '') +
            '</span>'
          );
        }

        renderCaseLine(bundle, caseCents, caseType, discount) {
          var panelId = 'case-' + bundle.index;
          var open = this.openPanel === panelId;
          var meta = [this.modelTitle, caseType].filter(Boolean).join(' • ');
          var out = '<div class="bundle-line">';
          out += this.thumb(this.config.case.image, this.config.case.title);
          out += '<div class="bundle-line__info">';
          out += '<div class="bundle-line__title">' + esc(this.config.case.title);
          if (this.text.thisProduct) out += ' <span class="bundle-line__chip">' + esc(this.text.thisProduct) + '</span>';
          out += '</div>';
          if (meta) out += '<div class="bundle-line__meta">' + esc(meta) + '</div>';
          if (caseCents !== null) out += '<div class="bundle-line__prices">' + this.priceHtml(caseCents, discount) + '</div>';
          out += '</div>';
          out += this.dotsButton(panelId, open);
          out += '</div>';
          if (open) out += this.renderCasePanel();
          return out;
        }

        renderLine(bundle, line, discount) {
          var slot = line.slot;
          var panelId = 'slot-' + bundle.index + '-' + slot.slot;
          var open = this.openPanel === panelId;
          var hasDesigns = slot.type === 'collection_design' && slot.items.length > 1;
          var availableVariants = line.item.variants.filter((v) => v.available);
          var hasVariants = slot.type !== 'product_model' && availableVariants.length > 1;
          var meta = line.variant.title && line.variant.title !== 'Default Title' ? line.variant.title : '';
          if (slot.type === 'collection_design' && line.item.title) meta = [meta, line.item.title].filter(Boolean).join(' • ');

          var out = '<div class="bundle-line">';
          out += this.thumb(line.variant.image || line.item.image, line.item.title);
          out += '<div class="bundle-line__info">';
          out += '<div class="bundle-line__title">' + esc(slot.label || line.item.title) + '</div>';
          if (meta) out += '<div class="bundle-line__meta">' + esc(meta) + '</div>';
          out += '<div class="bundle-line__prices">' + this.priceHtml(line.variant.price, discount) + '</div>';
          out += '</div>';
          if (hasDesigns || hasVariants) out += this.dotsButton(panelId, open);
          else out += '<span class="bundle-line__dots-space"></span>';
          out += '</div>';

          if (open) {
            out += '<div class="bundle-panel">';
            if (hasVariants) {
              out += '<label class="bundle-panel__label">' + esc(this.text.options || '') + '</label>';
              out += '<select class="bundle-panel__select" data-slot-variant="' + slot.slot + '">';
              availableVariants.forEach(function (v) {
                out += '<option value="' + v.id + '"' + (v.id === line.variant.id ? ' selected' : '') + '>' + esc(v.title) + '</option>';
              });
              out += '</select>';
            }
            if (hasDesigns) {
              out += '<div class="bundle-panel__label">' + esc(this.text.design || '') + '</div>';
              out += '<div class="bundle-panel__designs">';
              slot.items.forEach((item, index) => {
                out +=
                  '<button type="button" class="bundle-panel__design' + (index === slot.itemIndex ? ' is-active' : '') + '" data-slot-design="' + slot.slot + '" data-index="' + index + '" title="' + esc(item.title) + '">' +
                  this.thumb(item.image, item.title) +
                  '<span>' + esc(item.title) + '</span></button>';
              });
              out += '</div>';
            }
            out += '</div>';
          }
          return out;
        }

        dotsButton(panelId, open) {
          return (
            '<button type="button" class="bundle-line__dots" data-panel="' + panelId + '" aria-expanded="' + open + '" aria-label="' + esc(this.text.options || 'Options') + '">' +
            '<span></span><span></span><span></span></button>'
          );
        }

        renderCasePanel() {
          var out = '<div class="bundle-panel">';
          var select = this.modelSelect();
          if (select) {
            out += '<label class="bundle-panel__label">' + esc(this.text.model || '') + '</label>';
            out += '<select class="bundle-panel__select" data-case-model>';
            Array.prototype.forEach.call(select.options, function (option) {
              out += '<option value="' + esc(option.value) + '"' + (option.selected ? ' selected' : '') + (option.disabled ? ' disabled' : '') + '>' + esc(option.textContent.trim()) + '</option>';
            });
            out += '</select>';
          }
          var swatches = this.easifySwatches();
          if (swatches.length) {
            var current = this.caseTypeLabel().toLowerCase();
            out += '<div class="bundle-panel__label">' + esc(this.text.caseType || '') + '</div>';
            out += '<div class="bundle-panel__types">';
            swatches.forEach(function (root, index) {
              var priceEl = root.querySelector('.po-imageOption-price');
              var labelEl = root.querySelector('.po-optionSwatch-labelText, .po-optionSwatch-label, .po-imageOption-label');
              var label = labelEl ? labelEl.textContent : root.textContent;
              if (priceEl) label = label.replace(priceEl.textContent, '');
              label = label.trim().split('\n')[0].trim();
              var active = current && label.toLowerCase().indexOf(current) === 0;
              out += '<button type="button" class="bundle-panel__type' + (active ? ' is-active' : '') + '" data-case-type="' + index + '">' + esc(label) + '</button>';
            });
            out += '</div>';
          }
          // Designs from the More Designs block (hidden in bundle mode); clicking one opens that design
          var designLinks = Array.prototype.slice.call(document.querySelectorAll('more-designs a.more-designs__item'));
          if (designLinks.length) {
            out += '<div class="bundle-panel__label">' + esc(this.text.changeDesign || this.text.design || '') + '</div>';
            out += '<div class="bundle-panel__designs">';
            designLinks.forEach((link) => {
              var img = link.querySelector('img');
              var title = (link.querySelector('.more-designs__title') || link).textContent.trim();
              out +=
                '<button type="button" class="bundle-panel__design' + (link.hasAttribute('aria-current') ? ' is-active' : '') + '" data-case-design="' + esc(link.dataset.mdHandle) + '" title="' + esc(title) + '">' +
                this.thumb(img ? img.currentSrc || img.src : '', title) +
                '<span>' + esc(title) + '</span></button>';
            });
            out += '</div>';
          }
          out += '</div>';
          return out;
        }

        updateSaving(caseCents) {
          var box = this.querySelector('[data-bundle-saving]');
          var textEl = this.querySelector('[data-bundle-saving-text]');
          if (!box || !textEl) return;
          var entry = (this.available || []).find((a) => a.bundle.index === this.selectedIndex);
          this.currentTotal = null;
          if (!entry || caseCents === null) {
            box.hidden = true;
            return;
          }
          var discount = parseFloat(entry.bundle.discount) || 0;
          var full = caseCents;
          entry.lines.forEach(function (line) {
            full += line.variant.price;
          });
          this.currentTotal = this.bundleTotal(caseCents, entry.lines, discount);
          var saving = full - this.currentTotal;
          if (saving <= 0 || !this.text.youSave) {
            box.hidden = true;
            return;
          }
          textEl.textContent = this.text.youSave.replace('[amount]', money(saving));
          box.hidden = false;
        }

        /* Add to cart button price: show the bundle total in bundle mode,
           restore the theme's own text in product-only mode */
        syncButtonPrice() {
          var form = mainFormFor(this.sectionId);
          var scope = form || this.info;
          if (!scope) return;
          var spans = scope.querySelectorAll('.buttonPrice');
          var bundleMode = this.isBundleMode() && typeof this.currentTotal === 'number';
          var total = this.currentTotal;
          spans.forEach(function (span) {
            if (bundleMode) {
              // theme may have re-rendered the button: remember its current text
              if (span.dataset.bundleApplied !== span.textContent) span.dataset.themeText = span.textContent;
              var base = span.dataset.themeText || span.textContent;
              var next = /\d/.test(base)
                ? base.replace(/[^\s—–-]*\d[\d.,\s]*[^\s]*\s*$/, money(total))
                : base;
              if (span.textContent !== next) span.textContent = next;
              span.dataset.bundleApplied = next;
            } else if (span.dataset.themeText !== undefined && span.dataset.bundleApplied === span.textContent) {
              span.textContent = span.dataset.themeText;
              delete span.dataset.themeText;
              delete span.dataset.bundleApplied;
            }
          });
        }

        /* ----- events ----- */

        onClick(event) {
          var selectBtn = event.target.closest('[data-bundle-select]');
          if (selectBtn) {
            this.selectedIndex = parseInt(selectBtn.dataset.bundleSelect, 10);
            this.openPanel = null;
            this.render();
            return;
          }
          var dots = event.target.closest('[data-panel]');
          if (dots) {
            this.openPanel = this.openPanel === dots.dataset.panel ? null : dots.dataset.panel;
            this.render();
            return;
          }
          var design = event.target.closest('[data-slot-design]');
          if (design) {
            var slot = this.slots[design.dataset.slotDesign];
            slot.itemIndex = parseInt(design.dataset.index, 10);
            slot.variantId = null;
            this.render();
            return;
          }
          var type = event.target.closest('[data-case-type]');
          if (type) {
            this.caseTypeChosen = true;
            var swatch = this.easifySwatches()[parseInt(type.dataset.caseType, 10)];
            if (swatch) {
              // Easify reacts to clicks on the swatch image wrapper
              var clickable =
                swatch.querySelector('.po-imageOption-swatchWrapperItem, .po-imageOption-swatchLabel, button, input, label, [role="radio"]') ||
                swatch;
              clickable.click();
            }
            setTimeout(this.render, 200);
            return;
          }
          var caseDesign = event.target.closest('[data-case-design]');
          if (caseDesign) {
            var link = document.querySelector('more-designs a.more-designs__item[data-md-handle="' + caseDesign.dataset.caseDesign + '"]');
            if (!link || link.hasAttribute('aria-current')) return;
            try {
              sessionStorage.setItem('bundle-mode', 'bundle');
            } catch (e) {}
            // more-designs handles the click (keeps the selected phone model)
            link.click();
          }
        }

        onChange(event) {
          var target = event.target;
          if (target.matches('[data-slot-variant]')) {
            this.slots[target.dataset.slotVariant].variantId = parseInt(target.value, 10);
            this.render();
            return;
          }
          if (target.matches('[data-case-model]')) {
            var select = this.modelSelect();
            if (select) {
              select.value = target.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }

        /* ----- add to cart ----- */

        isBundleMode() {
          return this.info && this.info.getAttribute('data-bundle-mode') === 'bundle';
        }

        /* Runs before the theme's submit handler (capture phase). */
        onSubmit(event) {
          var form = event.target;
          if (!(form instanceof HTMLFormElement)) return;
          // form.id would return the <input name="id"> element, so read the attribute
          var inMain = form.getAttribute('id') === 'product-form-' + this.sectionId;
          var inSticky = !!form.closest('#sticky-atc-' + this.sectionId);
          if (!inMain && !inSticky) return;

          this.pending = null;
          this.hideError();
          if (!this.isBundleMode()) return;

          var entry = (this.available || []).find((a) => a.bundle.index === this.selectedIndex);
          if (!entry) return;

          var bundleId = entry.bundle.index + '-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
          var props = { _bundle: entry.bundle.title || 'Bundle', _bundle_id: bundleId };

          // Mark the case line too (removed again right after the theme reads the form)
          var added = [];
          // _bundle_case marks the case line, so the cart sync finds it even when
          // the Case Type property (Easify) is missing
          var caseProps = Object.assign({ _bundle_case: '1' }, props);
          Object.keys(caseProps).forEach(function (key) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'properties[' + key + ']';
            input.value = caseProps[key];
            form.appendChild(input);
            added.push(input);
          });
          setTimeout(function () {
            added.forEach(function (input) {
              input.remove();
            });
          }, 0);

          var idInput = form.querySelector('[name="id"]');
          this.pending = {
            items: entry.lines.map(function (line) {
              return { id: line.variant.id, quantity: 1, properties: props };
            }),
            mainVariantId: idInput ? String(idInput.value) : null,
            at: Date.now(),
          };

          // Safety net: if the theme's cart event never reaches us, or is dropped
          // (another app took over the add, a cart error event, a variant mismatch),
          // check the cart and add the accessories once the case line of this
          // bundle is there without its accessories. Checked twice.
          var job = { bundleId: bundleId, items: this.pending.items, done: false };
          this.pending.job = job;
          // also kept in sessionStorage: cart-bundle-sync finishes the job if this page
          // is reloaded or left before the accessories are added
          saveBundleJob(bundleId, job.items);
          // The bundle discount attribute is written just before the accessories are added
          // (see addAccessories), not in parallel with the case add: a parallel cart write
          // could drop the case line.
          job.caseId = this.pending.mainVariantId;
          var check = () => {
            if (job.done) return;
            fetch('/cart.js', { credentials: 'same-origin' })
              .then((r) => r.json())
              .then((cart) => {
                if (job.done) return;
                var lines = (cart.items || []).filter(function (l) {
                  return l.properties && l.properties._bundle_id === bundleId;
                });
                if (lines.length === 1) {
                  job.done = true;
                  if (this.pending && this.pending.job === job) this.pending = null;
                  this.addAccessories(job.items, job.caseId);
                }
              })
              .catch(function () {});
          };
          setTimeout(check, 3500);
          setTimeout(check, 8000);
        }

        onCartUpdate(event) {
          if (!this.pending || !event || event.source !== 'product-form') return;
          var pending = this.pending;
          if (Date.now() - pending.at > PENDING_TTL) return;
          if (pending.mainVariantId && event.productVariantId && String(event.productVariantId) !== pending.mainVariantId) return;
          this.pending = null;
          if (pending.job) {
            if (pending.job.done) return;
            pending.job.done = true;
          }
          this.addAccessories(pending.items, pending.mainVariantId);
        }

        addAccessories(items, caseId) {
          var jobId = items && items[0] && items[0].properties && items[0].properties._bundle_id;
          if (jobId) {
            if (bundleJobDone(jobId)) return; // already added (by the cart sync)
            markBundleJob(jobId);
          }
          var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          var body = { items: items };
          if (cart && typeof cart.getSectionsToRender === 'function') {
            body.sections = cart.getSectionsToRender().map(function (s) {
              return s.id;
            });
            body.sections_url = window.location.pathname;
          }
          var config =
            typeof fetchConfig === 'function'
              ? fetchConfig('javascript')
              : { method: 'POST', headers: { 'Content-Type': 'application/json' } };
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.body = JSON.stringify(body);

          var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
          // The case is in the cart now: write the bundle discount attribute first, so the
          // cart shows the bundle price as soon as the accessories arrive (one price change).
          // cart-bundle-sync.js keeps the attribute in line with the real cart afterwards.
          var entryItems = (items || []).map(function (item) {
            return [item.id, item.quantity || 1];
          });
          var writeAttr = caseId
            ? fetch('/cart.js', { credentials: 'same-origin' })
                .then(function (r) {
                  return r.json();
                })
                .then(function (cart) {
                  var list = [];
                  try {
                    list = JSON.parse((cart.attributes && cart.attributes._bundles) || '[]');
                  } catch (e) {}
                  if (!Array.isArray(list)) list = [];
                  list.push([parseInt(caseId, 10), 1, entryItems]);
                  return fetch('/cart/update.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: { _bundles: JSON.stringify(list) } }),
                  });
                })
                .catch(function () {})
            : Promise.resolve();
          writeAttr
            .then(function () {
              return fetch(addUrl, config);
            })
            .then(function (r) {
              return r.json();
            })
            .then((response) => {
              if (response.status) {
                this.showError(response.description || response.message);
                return;
              }
              if (cart && typeof cart.renderContents === 'function' && response.sections) {
                cart.renderContents(response);
              }
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-bundle', cartData: response });
              }
              document.dispatchEvent(new CustomEvent('cartUpdated'));
            })
            .catch((e) => {
              console.error(e);
              this.showError();
            });
        }

        showError(message) {
          var el = this.querySelector('[data-bundle-error]');
          if (!el) return;
          el.textContent = message || this.text.error || 'Bundle items could not be added to the cart.';
          el.hidden = false;
        }

        hideError() {
          var el = this.querySelector('[data-bundle-error]');
          if (el) el.hidden = true;
        }
      }
    );
  }
})();